module.exports = __webpack_public_path__ + "static/media/takeaway.0e85384d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/takeaway.svg
// module id = 2251
// module chunks = 0